import Layout from "@/components/feature/Layout";
import ServicePage from "@/components/feature/ServicePage";

const data = {
  heroTitle: "Apartman temizliği hizmeti",
  heroDescription: "Adana apartman temizliği hizmetiyle merdiven, giriş, ortak alan ve bina çevresinde düzenli hijyen sağlayın.",
  description: "Apartman temizliği, bina sakinlerinin günlük yaşam kalitesini doğrudan etkiler. Day Temizlik Adana, apartmanların kullanım yoğunluğuna göre haftalık, aylık veya ihtiyaca özel temizlik planları oluşturur. Ortak alanların temiz, düzenli ve hijyenik kalması için profesyonel destek sağlar. Adana apartman temizliği arayışlarınıza güvenilir ve planlı çözümler sunuyoruz.",
  scope: [
    "Apartman merdiven temizliği",
    "Giriş ve lobi alanı temizliği",
    "Korkuluk ve uygun yüzey silimi",
    "Zemin temizliği",
    "Ortak kullanım alanlarının düzenlenmesi",
    "Periyodik temizlik takibi",
  ],
  forWho: [
    "Apartman sakinleri",
    "Apartman yöneticileri",
    "Bina sahipleri",
    "Kiracı toplulukları",
  ],
  process: [
    "Apartman yapısını ve kullanım yoğunluğunu değerlendiriyoruz.",
    "Sakinlerin beklentilerini dinleyerek özel plan hazırlıyoruz.",
    "Haftalık veya aylık periyodik takvim oluşturuyoruz.",
    "Belirlenen gün ve saatlerde düzenli temizlik uyguluyoruz.",
    "Kontrol ve geri bildirim süreciyle kaliteyi sürdürüyoruz.",
  ],
  whyProfessional: [
    "Apartmanların günlük kullanım yoğunluğu profesyonel planlama gerektirir.",
    "Düzenli temizlik bina sakinlerinin memnuniyetini artırır.",
    "Hijyenik ortamlar sağlıklı yaşam için önemlidir.",
    "Profesyonel ekip ve ekipman daha etkili sonuç verir.",
    "Planlı hizmet sayesinde hizmet aksamaz.",
  ],
  relatedServices: [
    { title: "Bina ve Site Temizliği", path: "/hizmetlerimiz/bina-ve-site-temizligi" },
    { title: "Profesyonel Apartman ve Site Yönetimi", path: "/hizmetlerimiz/profesyonel-apartman-ve-site-yonetimi" },
    { title: "İlaçlama", path: "/hizmetlerimiz/ilaclama" },
  ],
  faqs: [
    { question: "Apartman temizliği düzenli yapılabilir mi?", answer: "Evet, apartman temizliği haftalık, aylık veya ihtiyaca özel periyodik planlarla düzenli yapılabilir." },
    { question: "Hangi alanlar temizlenir?", answer: "Merdiven, giriş, lobi, korkuluklar, zeminler ve ortak kullanım alanları temizlenir." },
    { question: "Fiyatlar nasıl belirlenir?", answer: "Apartmanın kat sayısı, ortak alan büyüklüğü ve temizlik sıklığına göre fiyat belirlenir." },
  ],
  ctaText: "Apartmanınız için profesyonel temizlik planı oluşturun.",
  heroImage: "/assets/images/apartman-temizligi.jpg",
};

export default function ApartmanTemizligiPage() {
  return (
    <Layout>
      <ServicePage data={data} />
    </Layout>
  );
}